import React from 'react';
import PropTypes from 'prop-types';

import marketplace from 'cfg/marketplace.json';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';

import css from 'styles/components/search/facetActions.scss';

const { search: { hasFacetListClear } } = marketplace;
export const FacetActions = ({ clearFacetGroup, selectedFacet, facetDone, mobileCloseFiltersText, mobileRemoveSelectionsText }, { testId }) => (
  <div className={css.facetActions}>
    <button
      type="button"
      className={css.resetFacets}
      onClick={clearFacetGroup}
      data-test-id={testId('resetFacets')}>
      {mobileRemoveSelectionsText} {(hasFacetListClear && selectedFacet) ? selectedFacet.facetFieldDisplayName : 'All'}
    </button>
    <button
      type="button"
      data-test-id={testId('facetDone')}
      className={css.done}
      onClick={facetDone}>
      {mobileCloseFiltersText}
    </button>
  </div>
);

FacetActions.displayName = 'FacetActions';
FacetActions.contextTypes = {
  testId: PropTypes.func
};

export default withErrorBoundary('FacetActions', FacetActions);
